module.exports = __webpack_public_path__ + "img/HEALTH INDIA_LOGO.62916cb4.jpeg";